import React from 'react';
import { H4 } from 'atoms';
import { Fade } from "react-awesome-reveal";
import { useDispatchUi } from 'context/ui';
import { PlayButton } from '../PlayButton';
// Import Image from 'next/legacy/image';

export const WhyWeStarted = ({ heading, subhead, videoLink, featuredImage }) => {
    const dispatch: any = useDispatchUi();
    return (
        <div className='wws'>
            <Fade>
                <div className='wws__content'>
                    <H4 style={{ color: '#121651', textAlign: 'center' }}>{subhead}</H4>
                </div>
                <div className='video-card'>
                    <div>
                        <h3 className='heading'>{heading}</h3>
                    </div>
                    <div />
                    {/*
          <Image

            data={featuredImage.responsiveImage}
            className={'lana-picture'}
            pictureClassName={'lana-picture'}
          />
          */}

                    <img
                        id='lana'
                        src='/assets/graphics/lana-portrait2.png'
                        // Width={814}
                        // height={529}
                        className='lana-picture'
                        alt='Lana Israel'
                    />
                    <div className='wws__play-btn'>
                        <PlayButton videoLink={videoLink} parentStyle={{}} onClick={null} />
                    </div>
                </div>
            </Fade>
            <style jsx>
                {`
                    .wws__play-btn {
                        margin-top: 112px;
                    }

                    .wws {
                        padding: 60px 60px 20px;
                        width: 100%;
                        background-color: #f9f9f9;
                    }

                    .wws__content {
                        margin: 0 auto;
                        max-width: 1100px;
                    }

                    .video-card {
                        display: flex;
                        position: relative;
                        height: 320px;
                        width: 100%;
                        background-color: #e8e8e8;
                        border: 8px solid #fff;
                        margin: 80px auto;
                        max-width: 940px;
                        border-radius: 12px;
                        position: relative;

                        > div:first-child {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            max-width: 400px;
                            padding: 16px 48px;
                            font-family: Avenir, "Avenir", sans-serf, serif;
                            font-style: normal;
                            font-weight: 800;
                            font-size: 42px;
                            line-height: 52px;

                            h3 {
                                background: -webkit-linear-gradient(#e637a8, #e68037);
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                                padding-bottom: 16px;
                            }
                        }

                        #play-btn {
                            max-width: 140px;
                            width: 30%;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            transition: filter 150ms linear;

                            &:hover {
                                filter: brightness(0.8);
                                cursor: pointer;
                            }
                        }

                        #lana {
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            max-width: 62%;
                        }

                        .lana-picture {
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            max-width: 62%;
                        }
                    }

                    @media (max-width: 992px) {
                        .wws {
                            padding: 48px 40px;
                            width: 100%;
                            background-color: #f9f9f9;

                            .heading {
                                font-size: 42px;
                            }
                        }

                        .video-card {
                            margin: 48px auto;
                        }
                    }

                    @media (max-width: 520px) {
                        .video-card {
                            > div:first-child {
                                padding: 16px 40px;
                                align-items: flex-start;
                            }
                        }

                        .wws__play-btn {
                            margin-top: 132px;
                        }

                        .wws {
                            padding: 48px 20px;
                            width: 100%;
                            background-color: #f9f9f9;

                            .heading {
                                font-size: 34px;
                                text-align: center;
                                line-height: 110%;
                                margin-top: -5px;
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
};
